import Header from "../sections/Header";
import Footer from "../sections/Footer";
import Recruitment from "../sections/Recruitment";

export default function CaregiversPage() {
  return (
    <div data-testid="caregivers-page" className="min-h-screen bg-[#FFFFFF]">
      <Header />
      <Recruitment standalone />
      <Footer />
    </div>
  );
}
